
import { defineComponent } from "vue";
import KycVerificationDetail from "@/components/page/kyc/kyc-verification/Detail.vue";

export default defineComponent({
  name: "kyc-verification-natural-person-detail",
  components: {
    KycVerificationDetail,
  },
  setup() {
    return {};
  },
});
